import { SET_CURRENT_CUSTOMERS } from "actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CURRENT_CUSTOMERS:
      return action.payload;
    default:
      return state;
  }
};
